module.exports = __webpack_public_path__ + "static/media/down-arrow.6c53add2.svg";